import * as React from 'react';

import { cn } from '@codes/ui-kit/utils';
import { type VariantProps, cva } from 'class-variance-authority';

const badgeVariants = cva(
    'border-transparent shrink-0 inline-flex items-center justify-center rounded-full border px-2.5 py-0.5 text-xs whitespace-nowrap font-medium transition-colors focus:outline-none',
    {
        variants: {
            variant: {
                A: 'bg-badge text-badge-text uppercase',
                B: 'text-white bg-secondary uppercase',
                C: 'h-6 rounded-full py-0.5 px-2.5 text-white capitalize border-[0.6px] text-xs font-medium shadow-xs',
                default: 'bg-badge text-badge-text uppercase',
                secondary: 'bg-gray-100 text-gray-600 text-xs',
                success: 'bg-[#D4E3FF] text-[#00379F] text-xs',
                warning: 'bg-[#FEF8C9] text-[#6D570A] text-xs',
                destructive: 'bg-[#FFE4DF] text-[#CE1A00] text-xs',
                outline: 'text-foreground border border-border bg-background',
                service: 'capitalize px-2.5 h-6 text-xs font-medium',
            },
        },
        defaultVariants: {
            variant: 'A',
        },
    }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
